/* SupportContactDetails.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _17 = "@media (min-width:48rem){._seov1qlw{margin-left:var(--_we1d56)}}";
const _16 = "._19pkutpp{margin-top:var(--ds-space-150,9pt)}";
const _15 = "._1e0c1o8l{display:inline-block}";
const _14 = "._18u0idpf{margin-left:0}";
const _13 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _12 = "._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}";
const _11 = "._18s81j51{margin:var(--_1jdduoh)}";
const _10 = "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _9 = "@media (min-width:48rem){._14b5tye8{width:20rem}}";
const _8 = "._1bsb1osq{width:100%}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField, Fieldset } from '@atlaskit/form';
import { media } from '@atlaskit/primitives/responsive';
import { H3 } from '@atlassian/mpac-primitives';
import { TextInput } from '@atlassian/mpac-ui';
import { TopVendorProgramHelper } from '../HelpText';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _7 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _6 = "._19bvidpf{padding-left:0}";
const _5 = "@media (min-width:48rem){._6ytt47zb{padding:var(--_o3usm9)}}";
const _4 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._11c8lodh{font:var(--ds-font-heading-medium,normal 500 20px/24px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _ = "._1yt4zmd4{padding:var(--_1aun1c5)}";
const FieldsetTitleH3 = null;
const LeftPadding = null;
const SupportModeInfoLabel = null;
const FieldWidth20 = null;
export const SupportContactDetails = _ref => {
  let {
    submissionErrors
  } = _ref;
  return /*#__PURE__*/_jsx(Fieldset, {
    legend: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5]
      }), /*#__PURE__*/_jsx(H3, {
        className: ax(["_1yt4zmd4 _11c8lodh _otyridpf _k48p1wq8 _6ytt47zb"]),
        style: {
          "--_1aun1c5": ix("var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-050, 4px)")),
          "--_o3usm9": ix("var(--ds-space-400, 32px)".concat(" 0 ", "var(--ds-space-025, 2px)"))
        },
        children: "Support contact details"
      })]
    }),
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_6, _7]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_19bvidpf _1r3v1epz"]),
        children: /*#__PURE__*/_jsx(CheckboxField, {
          name: "provideSupportContactDetails",
          children: _ref2 => {
            let {
              fieldProps
            } = _ref2;
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, fieldProps), {}, {
                label: "Provide support contact details",
                name: "provideSupportContactDetails"
              })), fieldProps.isChecked && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_8, _9]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1bsb1osq _14b5tye8"]),
                    children: /*#__PURE__*/_jsx(TextInput, {
                      name: "supportName",
                      label: "Support name",
                      width: "100%",
                      helperMessage: "Provide a name for your support organization. Leave blank to use your vendor organization name.",
                      submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.supportName
                    })
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_10, _11, _12, _13, _14, _15, _16, _17]
                  }), /*#__PURE__*/_jsx("p", {
                    className: ax(["_11c82smr _18s81j51 _k48pi7a9 _syaz1gjq _18u0idpf _1e0c1o8l _19pkutpp _seov1qlw"]),
                    style: {
                      "--_1jdduoh": ix("var(--ds-space-100, 8px)".concat(" 0 ", "var(--ds-space-050, 4px)")),
                      "--_we1d56": ix("-".concat("var(--ds-space-800, 64px)"))
                    },
                    children: "Provide at least one mode of support."
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_8, _9]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1bsb1osq _14b5tye8"]),
                    children: /*#__PURE__*/_jsx(TextInput, {
                      name: "supportEmail",
                      label: "Support email",
                      width: "100%",
                      type: "email",
                      applyDefaultValidation: true,
                      submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.supportEmail
                    })
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_8, _9]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1bsb1osq _14b5tye8"]),
                    children: /*#__PURE__*/_jsx(TextInput, {
                      name: "supportUrl",
                      label: "Support URL",
                      width: "100%",
                      type: "url",
                      applyDefaultValidation: true,
                      helperMessage: TopVendorProgramHelper,
                      submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.supportUrl
                    })
                  })]
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_8, _9]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1bsb1osq _14b5tye8"]),
                    children: /*#__PURE__*/_jsx(TextInput, {
                      name: "supportPhone",
                      label: "Support phone",
                      width: "100%",
                      helperMessage: "Provide your full support telephone number, including your country code.",
                      submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.supportPhone
                    })
                  })]
                })]
              })]
            });
          }
        })
      })]
    })
  });
};